module.exports = __webpack_public_path__ + "media/images/web-51970e8a.svg";